/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Pagination_Gotoprevious2Inputs */

const id_table_pagination_gotoprevious2 = /** @type {(inputs: Table_Pagination_Gotoprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pergi ke halaman sebelumnya`)
};

const ms_table_pagination_gotoprevious2 = /** @type {(inputs: Table_Pagination_Gotoprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pergi ke halaman sebelumnya`)
};

const da_table_pagination_gotoprevious2 = /** @type {(inputs: Table_Pagination_Gotoprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå til forrige side`)
};

const de_table_pagination_gotoprevious2 = /** @type {(inputs: Table_Pagination_Gotoprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zur vorherigen Seite`)
};

const en_us2_table_pagination_gotoprevious2 = /** @type {(inputs: Table_Pagination_Gotoprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to previous page`)
};

const es_es2_table_pagination_gotoprevious2 = /** @type {(inputs: Table_Pagination_Gotoprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir a la página anterior`)
};

const es_mx2_table_pagination_gotoprevious2 = /** @type {(inputs: Table_Pagination_Gotoprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir a la página anterior`)
};

const fil_table_pagination_gotoprevious2 = /** @type {(inputs: Table_Pagination_Gotoprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pumunta sa nakaraang pahina`)
};

const fr_table_pagination_gotoprevious2 = /** @type {(inputs: Table_Pagination_Gotoprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller à la page précédente`)
};

const it_table_pagination_gotoprevious2 = /** @type {(inputs: Table_Pagination_Gotoprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai alla pagina precedente`)
};

const hu_table_pagination_gotoprevious2 = /** @type {(inputs: Table_Pagination_Gotoprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ugrás az előző oldalra`)
};

const nl_table_pagination_gotoprevious2 = /** @type {(inputs: Table_Pagination_Gotoprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ga naar vorige pagina`)
};

const no_table_pagination_gotoprevious2 = /** @type {(inputs: Table_Pagination_Gotoprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå til forrige side`)
};

const pl_table_pagination_gotoprevious2 = /** @type {(inputs: Table_Pagination_Gotoprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przejdź do poprzedniej strony`)
};

const pt_br2_table_pagination_gotoprevious2 = /** @type {(inputs: Table_Pagination_Gotoprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to previous page`)
};

const pt_table_pagination_gotoprevious2 = /** @type {(inputs: Table_Pagination_Gotoprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir para a página anterior`)
};

const ro_table_pagination_gotoprevious2 = /** @type {(inputs: Table_Pagination_Gotoprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mergi la pagina anterioară`)
};

const fi_table_pagination_gotoprevious2 = /** @type {(inputs: Table_Pagination_Gotoprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siirry edelliselle sivulle`)
};

const sv_table_pagination_gotoprevious2 = /** @type {(inputs: Table_Pagination_Gotoprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå till föregående sida`)
};

const vi_table_pagination_gotoprevious2 = /** @type {(inputs: Table_Pagination_Gotoprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đến trang trước`)
};

const tr_table_pagination_gotoprevious2 = /** @type {(inputs: Table_Pagination_Gotoprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Önceki sayfaya git`)
};

const cs_table_pagination_gotoprevious2 = /** @type {(inputs: Table_Pagination_Gotoprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přejít na předchozí stránku`)
};

const bg_table_pagination_gotoprevious2 = /** @type {(inputs: Table_Pagination_Gotoprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отидете на предишна страница`)
};

const ru_table_pagination_gotoprevious2 = /** @type {(inputs: Table_Pagination_Gotoprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти на предыдущую страницу`)
};

const uk_table_pagination_gotoprevious2 = /** @type {(inputs: Table_Pagination_Gotoprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти на попередню сторінку`)
};

const ar_table_pagination_gotoprevious2 = /** @type {(inputs: Table_Pagination_Gotoprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انتقل إلى الصفحة السابقة`)
};

const hi_table_pagination_gotoprevious2 = /** @type {(inputs: Table_Pagination_Gotoprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछले पृष्ठ पर जाएँ`)
};

const th_table_pagination_gotoprevious2 = /** @type {(inputs: Table_Pagination_Gotoprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไปหน้าก่อนหน้า`)
};

const ja_table_pagination_gotoprevious2 = /** @type {(inputs: Table_Pagination_Gotoprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前のページへ`)
};

const zh_cn2_table_pagination_gotoprevious2 = /** @type {(inputs: Table_Pagination_Gotoprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to previous page`)
};

const zh_hant1_table_pagination_gotoprevious2 = /** @type {(inputs: Table_Pagination_Gotoprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to previous page`)
};

const ko_table_pagination_gotoprevious2 = /** @type {(inputs: Table_Pagination_Gotoprevious2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to previous page`)
};

/**
* | output |
* | --- |
* | "Go to previous page" |
*
* @param {Table_Pagination_Gotoprevious2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const table_pagination_gotoprevious2 = /** @type {((inputs?: Table_Pagination_Gotoprevious2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Pagination_Gotoprevious2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_table_pagination_gotoprevious2(inputs)
	if (locale === "ms") return ms_table_pagination_gotoprevious2(inputs)
	if (locale === "da") return da_table_pagination_gotoprevious2(inputs)
	if (locale === "de") return de_table_pagination_gotoprevious2(inputs)
	if (locale === "en-US") return en_us2_table_pagination_gotoprevious2(inputs)
	if (locale === "es-ES") return es_es2_table_pagination_gotoprevious2(inputs)
	if (locale === "es-MX") return es_mx2_table_pagination_gotoprevious2(inputs)
	if (locale === "fil") return fil_table_pagination_gotoprevious2(inputs)
	if (locale === "fr") return fr_table_pagination_gotoprevious2(inputs)
	if (locale === "it") return it_table_pagination_gotoprevious2(inputs)
	if (locale === "hu") return hu_table_pagination_gotoprevious2(inputs)
	if (locale === "nl") return nl_table_pagination_gotoprevious2(inputs)
	if (locale === "no") return no_table_pagination_gotoprevious2(inputs)
	if (locale === "pl") return pl_table_pagination_gotoprevious2(inputs)
	if (locale === "pt-BR") return pt_br2_table_pagination_gotoprevious2(inputs)
	if (locale === "pt") return pt_table_pagination_gotoprevious2(inputs)
	if (locale === "ro") return ro_table_pagination_gotoprevious2(inputs)
	if (locale === "fi") return fi_table_pagination_gotoprevious2(inputs)
	if (locale === "sv") return sv_table_pagination_gotoprevious2(inputs)
	if (locale === "vi") return vi_table_pagination_gotoprevious2(inputs)
	if (locale === "tr") return tr_table_pagination_gotoprevious2(inputs)
	if (locale === "cs") return cs_table_pagination_gotoprevious2(inputs)
	if (locale === "bg") return bg_table_pagination_gotoprevious2(inputs)
	if (locale === "ru") return ru_table_pagination_gotoprevious2(inputs)
	if (locale === "uk") return uk_table_pagination_gotoprevious2(inputs)
	if (locale === "ar") return ar_table_pagination_gotoprevious2(inputs)
	if (locale === "hi") return hi_table_pagination_gotoprevious2(inputs)
	if (locale === "th") return th_table_pagination_gotoprevious2(inputs)
	if (locale === "ja") return ja_table_pagination_gotoprevious2(inputs)
	if (locale === "zh-CN") return zh_cn2_table_pagination_gotoprevious2(inputs)
	if (locale === "zh-Hant") return zh_hant1_table_pagination_gotoprevious2(inputs)
	return ko_table_pagination_gotoprevious2(inputs)
});
export { table_pagination_gotoprevious2 as "table.pagination.goToPrevious" }